<template>
  <div class="box" :style="{height: rowHeight + 'px',top: -rowHeight + 'px'}">
    <div class="cell" v-for="(v, k) in loadFaceArray" :key="k" @click="chooseFace(v)">
      <img :src="v.src">
    </div>
  </div>
</template>
<script>
import Emoticon from '@/assets/data/emoticon'
import FaceObjConfig from '@/assets/data/faceObjConfig'
export default {
  mounted () {
    this.loadFace()
  },
  data () {
    const cellHeight = 29.5
    return {
      cellHeight, // 表情cell高度
      loadFaceArray: [], // 当前展示的标签数组
    }
  },
  methods: {
    // 生成表情
    loadFace () {
      let name = FaceObjConfig.showFace.name
      let type = FaceObjConfig.showFace.type
      let list = Emoticon[name]
      let arr = ['2', '15', '16']
      if (name === 'wx' && arr.indexOf(this.typeId) === -1) {
        list = [...list, ...Emoticon.extra]
      } else {
        this.loadFaceArray = [...list]
      }
      let currentFace = list.map((ev,i)=>{
        let obj={
          data: ev,
          src: require('@/assets/img/' + name + '/' + ev[0] + '.' + type),
          code: ev[0]
        }
        return obj;
      })
      this.loadFaceArray = currentFace;
    },
    /**
     * 将选择的表情传给父
     * Array ["[回头]", "/:turn"]
    */
    chooseFace (item) {
      this.$emit('getFace', item)
    }
  },
  computed: {
    rowHeight () {
      return this.loadFaceArray.length / 15 * this.cellHeight
    }
  }
}
</script>
<style lang="less" scoped>
@cellWidth: 29px;
.box {
  overflow-y: auto; 
  box-sizing: border-box;
  width: @cellWidth* 15 ;
  background: #fff;
  position: absolute;
  .cell {
    float: left;
    cursor: pointer;
    padding: 2.5px;
    box-sizing: border-box;
  }
  .cell:hover {
    background: rgba(0,0,0,0.15);
  }
  img {
    width: 24px;
    height: 24px;
  }
}
</style>
